<template>
    <swiper :class="{lstCarGallery: true, isModal: modalData.slotWrapClass == 'gal'}" ref="lstCarGallery" :options="swiperOptions">
        <swiper-slide v-for="(item, i) in content" :key="i">
            <img :src="item" alt="List Car Gallery">
        </swiper-slide>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
        <!-- <div class="swiper-pagination" slot="pagination"></div> -->
    </swiper>
</template>
<script>
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import SwiperCore, { Navigation, Pagination } from 'swiper';
    SwiperCore.use([Navigation, Pagination]);
    import 'swiper/swiper-bundle.css'
import { mapState } from 'vuex';

    export default {
        name: '',
        components: { Swiper, SwiperSlide,  },
        props:{
            content: {type: Array, default: () => { return []; }},
        },
        directives: {
            swiper: directive
        },
        data(){return{
            swiperOptions: {
                slidesPerView: 1,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        }},
        computed: {
            ...mapState(['modalData']),
            swiper(){
                return this.$refs.lstCarGallery.$swiper
            }
        },
    }
</script>
<style lang="scss" scoped>
    .lstCarGallery{
        margin: 2rem auto 3.5rem;
        
        img{
            // max-height: 168px;
            width: 100%;
            height: auto;
            overflow: hidden;
            -o-object-fit: cover;
            object-fit: cover;
        }
    }

    .swiper-button-prev{ &:after{
        content: url(../../../assets/svg/leftChev.svg);
    }}
    .swiper-button-next{ transform: rotate(180deg);
        &:after{ content: url(../../../assets/svg/leftChev.svg);
    }}

    @include respond-to(large){
        
        .lstCarGallery{ margin: 0;
            img{ max-height: 384px; }
        }

        .isModal img{
            max-height: 80vh;
            
        }
    }

</style>